import React from 'react';
import EntityState from '../EntityState';

export default props => <EntityState title="No resources found." hint="Currently there are no resources." {...props} />;
